export class ApiError extends Error { constructor(message: string, public status: number) { super(message); } }

export interface ApiRequestOptions { fresh?: boolean; signal?: AbortSignal }
let freshnessSequence = 0;

export async function api<T>(path: string, body?: unknown, token?: string, options: ApiRequestOptions = {}): Promise<T> {
  const freshQuery = options.fresh ? `${path.includes('?')?'&':'?'}fresh=${Date.now().toString(36)}-${(++freshnessSequence).toString(36)}` : '';
  const response = await fetch(`/.netlify/functions/${path}${freshQuery}`, {
    method: body === undefined ? 'GET' : 'POST',
    headers: { ...(body === undefined ? {} : { 'Content-Type': 'application/json' }), ...(token ? { Authorization: `Bearer ${token}` } : {}), ...(options.fresh ? { 'Cache-Control': 'no-cache', Pragma: 'no-cache' } : {}) },
    body: body === undefined ? undefined : JSON.stringify(body),
    ...(options.fresh ? { cache: 'no-store' as const } : {}),
    ...(options.signal ? { signal: options.signal } : {}),
  });
  const payload = await response.json().catch(() => ({})) as { error?: string };
  if (!response.ok) throw new ApiError(payload.error || 'The stars are briefly out of reach. Please try again.', response.status);
  return payload as T;
}
